var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipPath: "circle() view-box",
    d: "M-5-5h210v210H-5Zm136.544 85.5368 16.89-22.7246c-26.825-21.2856-67.7976-19.9519-91.3848 6.6173-7.8172 8.8056-12.8431 20.2932-13.4233 34.2281-.8072 19.3874 7.9013 37.3424 21.477 46.9804 25.679 18.229 60.2511 13.83 84.8941-3.451l-15.098-24.066c-18.121 14.094-51.3921 12.751-53.6913-15.437-2.2993-28.1873 28.8593-36.2411 50.3363-22.1472Z",
    className: "powerclip"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCara);
export default __webpack_public_path__ + "static/media/cara.bf92e80cdfae00c57ac3acec7426e225.svg";
export { ForwardRef as ReactComponent };